import React, { useEffect } from 'react';

const TestCondition = ({ formData, updateFormData, nextStep, prevStep, currentStep, totalSteps }) => {
  // Get test condition values based on model
  const getTestConditions = () => {
    const model = formData.model || '';
    
    if (model === '4031-OTI') {
      return [
        'Continuously stirred oil bath used for calibration & switch test',
        'Oil temperature reading taken after 5 minutes, once instrument reaches steady temperature',
      ];
    } else if (model === '4031-WTI') {
      return [
        'Continuously stirred oil bath used for calibration & switch test',
        'Oil temperature reading taken after 5 minutes, once instrument reaches steady temperature',
        'Bath Temperature maintained @60/75°C while checking the gradient. Instrument front bezel closed while testing',
        'Time allowed for checking the gradient is 40 minutes, after continuously passing the CT current through the inbuilt heater circuit.',
      ];
    } else if (model === '4031H-OTI') {
      return [
        'Continuously stirred oil bath used for calibration & switch test',
        'Oil temperature reading taken after 5 minutes, once instrument reaches steady temperature',
        'Channel-1 current output of CCU',
        '4-20mA Signal input & output terminals to earth High voltage test only for 500v AC 50Hz',
      ];
    } else if (model === '4031H-WTI') {
      return [
        'Continuously stirred oil bath used for calibration & switch test',
        'Oil temperature reading taken after 5 minutes, once instrument reaches steady temperature',
        'Bath Temperature maintained @ 60/75°C while checking the gradient. Instrument front bezel closed while testing',
        'Time allowed for checking the gradient is 40 minutes, after continuously passing the CT current through the inbuilt heater circuit.',
      ];
    } else {
      // Default fallback
      return [];
    }
  };

  const defaultConditions = getTestConditions();

  // Auto-populate test conditions when model changes
  useEffect(() => {
    if (formData.model && defaultConditions.length > 0) {
      const currentConditions = formData.testCondition || [];
      // Only update if the conditions are different
      if (JSON.stringify(currentConditions) !== JSON.stringify(defaultConditions)) {
        updateFormData({ testCondition: defaultConditions });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.model]);

  const handleConditionChange = (index, value) => {
    const newConditions = [...(formData.testCondition || [])];
    newConditions[index] = value;
    updateFormData({ testCondition: newConditions });
  };

  const conditions = formData.testCondition || defaultConditions;

  return (
    <div className="form-section">
      <h3>Test Condition</h3>
      
      <div className="table-container">
        <table className="test-table">
          <thead>
            <tr>
              <th style={{ width: '50px' }}>No.</th>
              <th>Test Condition</th>
            </tr>
          </thead>
          <tbody>
            {conditions.map((condition, index) => (
              <tr key={index}>
                <td style={{ textAlign: 'center', fontWeight: 'bold' }}>{index + 1}</td>
                <td>
                  <textarea
                    value={condition || ''}
                    onChange={(e) => handleConditionChange(index, e.target.value)}
                    rows="2"
                    style={{
                      width: '100%',
                      border: 'none',
                      textAlign: 'left',
                      background: 'transparent',
                      padding: '4px',
                      resize: 'vertical',
                      fontFamily: 'inherit',
                      fontSize: 'inherit',
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="navigation-buttons">
        <button 
          className="btn btn-secondary" 
          onClick={prevStep}
          disabled={currentStep === 1}
        >
          Previous
        </button>
        <button 
          className="btn btn-primary" 
          onClick={nextStep}
          disabled={currentStep === totalSteps}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default TestCondition;

